import { render, staticRenderFns } from "./BubbleLoader.vue?vue&type=template&id=ca297114&scoped=true"
import script from "./BubbleLoader.vue?vue&type=script&lang=js"
export * from "./BubbleLoader.vue?vue&type=script&lang=js"
import style0 from "./BubbleLoader.vue?vue&type=style&index=0&id=ca297114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca297114",
  null
  
)

export default component.exports